import React, { Suspense, useRef, useEffect, useState } from 'react';
import { Canvas, useLoader, useThree, useFrame } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import * as THREE from 'three';
import { FBXLoader } from 'three/addons/loaders/FBXLoader';

const FBXModel = ({ fbxFilePath, setModelCenter, modelCenter, percentageX, percentageY, percentageZ, setenableRotate, setpercentageX, setpercentageY, setpercentageZ }) => {
    const fbx = useLoader(FBXLoader, fbxFilePath);
    const fbxRef = useRef();
    const [boundingBox, setBoundingBox] = useState(null);
    const { camera } = useThree()
    const { scene } = useThree();
    const slicePlaneXRef = useRef(null)
    const slicePlaneYRef = useRef(null)
    const slicePlaneZRef = useRef(null)
    const [isDraggingX, setIsDraggingX] = useState(false);
    const [isDraggingY, setIsDraggingY] = useState(false);
    const [isDraggingZ, setIsDraggingZ] = useState(false);
    useEffect(() => {
        // 计算模型的包围盒
        const box = new THREE.Box3().setFromObject(fbxRef.current);
        setBoundingBox(box);
        // 获取包围盒中心点
        const center = new THREE.Vector3();
        box.getCenter(center);
        // 设置中心点
        setModelCenter([center.x, center.y, center.z]);
    }, []);
    
    useFrame((state) => {
        const { mouse } = state;
        const raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, camera);
        // 计算模型的边界框
        const boundingBox = new THREE.Box3().setFromObject(fbxRef.current);
        const virtualBoundingBox = new THREE.Box3(
            new THREE.Vector3(boundingBox.min.x,boundingBox.min.y,boundingBox.min.z),
            new THREE.Vector3(boundingBox.max.x,boundingBox.max.y,boundingBox.max.z)
        )
        if (isDraggingX) {
            const intersects = raycaster.intersectObject(fbxRef.current);
            if (intersects.length > 0) {
                setenableRotate(false)
                const intersection = intersects[0];
                const newPosition = intersection.point.clone();
                // 更新切片平面的位置
                newPosition.z = slicePlaneXRef.current.position.z;
                newPosition.y = slicePlaneXRef.current.position.y;
                slicePlaneXRef.current.position.copy(newPosition);
                setpercentageX((newPosition.x) / (boundingBox.max.x + boundingBox.min.x))
            }
        }
        if (isDraggingY) {
            const intersects = raycaster.intersectObject(fbxRef.current);
            if (intersects.length > 0) {
                setenableRotate(false)
                const intersection = intersects[0];
                const newPosition = intersection.point.clone();
                // 更新切片平面的位置
                newPosition.x = slicePlaneYRef.current.position.x;
                newPosition.z = slicePlaneYRef.current.position.z;
                slicePlaneYRef.current.position.copy(newPosition);
                setpercentageY((newPosition.y) / (boundingBox.max.y - boundingBox.min.y))
            }

        }
        if (isDraggingZ) {
            const intersects = raycaster.intersectObject(fbxRef.current);
            if (intersects.length > 0) {
                setenableRotate(false)
                const intersection = intersects[0];
                const newPosition = intersection.point.clone();

                // 更新切片平面的位置
                newPosition.x = slicePlaneZRef.current.position.x;
                newPosition.y = slicePlaneZRef.current.position.y;
                slicePlaneZRef.current.position.copy(newPosition);
                setpercentageZ((newPosition.z) / (boundingBox.max.z + boundingBox.min.z))

            }

        }
    });
    // 鼠标按下事件处理函数
    const handleMouseDown = (event, layer) => {
        if (layer == 'x') {
            setIsDraggingX(true)
            setIsDraggingY(false)
            setIsDraggingZ(false)
        }
        if (layer == 'y') {
            setIsDraggingY(true)
            setIsDraggingX(false)
            setIsDraggingZ(false)
        }
        if (layer == 'z') {
            setIsDraggingZ(true)
            setIsDraggingX(false)
            setIsDraggingY(false)
        }
    };

    // 鼠标抬起事件处理函数
    const handleMouseUp = () => {
        setIsDraggingX(false)
        setIsDraggingY(false)
        setIsDraggingZ(false)
        setenableRotate(true)
    };
    return (
        <group ref={fbxRef}>
            {boundingBox && (
                <>
                    {/* 创建 X 方向的切片平面 */}
                    <mesh ref={slicePlaneXRef}
                        position={[(boundingBox.max.x+boundingBox.min.x) * percentageX, modelCenter[1], modelCenter[2]]}
                        rotation={[Math.PI / 2, Math.PI / 2, 0]}
                        onPointerDown={(event) => handleMouseDown(event, 'x')}
                        onPointerUp={handleMouseUp}
                    >
                        <planeGeometry args={[boundingBox.max.y - boundingBox.min.y, boundingBox.max.z - boundingBox.min.z]} />
                        <meshBasicMaterial color="#72ece9" transparent opacity={0.5}
                        />
                    </mesh>

                    {/* 创建 Y 方向的切片平面 */}
                    <mesh ref={slicePlaneYRef}
                        position={[modelCenter[0], (boundingBox.max.y) * percentageY, modelCenter[2]]} rotation={[Math.PI / 2, 0, 0]}
                        onPointerDown={(event) => handleMouseDown(event, 'y')}
                        onPointerUp={handleMouseUp}>
                        <planeGeometry args={[boundingBox.max.x - boundingBox.min.x, boundingBox.max.z - boundingBox.min.z]} />
                        <meshBasicMaterial color="#72ece9" transparent opacity={0.5} />
                    </mesh>

                    {/* 创建 Z 方向的切片平面 */}
                    <mesh ref={slicePlaneZRef}
                        position={[modelCenter[0], modelCenter[1], (boundingBox.max.z + boundingBox.min.z) * percentageZ]} rotation={[0, 0, 0]}
                        onPointerDown={(event) => handleMouseDown(event, 'z')}
                        onPointerUp={handleMouseUp}>
                        <planeGeometry args={[boundingBox.max.x - boundingBox.min.x, boundingBox.max.y - boundingBox.min.y]} />
                        <meshBasicMaterial color="#72ece9" transparent opacity={0.5} />
                    </mesh>
                </>
            )}
            <primitive object={fbx} scale={0.01} position={[0, 0, 0]} />
        </group>
    );
}

const FbxViewer = ({ percentageX, percentageY, percentageZ, setpercentageX, setpercentageY, setpercentageZ }) => {
    const [modelCenter, setModelCenter] = useState([0, 0, 0]);
    const [enableRotate, setenableRotate] = useState(true)
    return (
        <div id="canvas-container">
            <Canvas camera={{ position: [10, 0, 5] }}>
                <ambientLight intensity={0.5} />
                <directionalLight intensity={0.5} position={[8, 2.5, 9]} />
                <FBXModel
                    fbxFilePath={'./outline.FBX'}
                    setModelCenter={setModelCenter}
                    modelCenter={modelCenter}
                    percentageX={percentageX}
                    percentageY={percentageY}
                    percentageZ={percentageZ}
                    setpercentageX={setpercentageX}
                    setpercentageY={setpercentageY}
                    setpercentageZ={setpercentageZ}
                    setenableRotate={setenableRotate} />
                <OrbitControls
                    enableDamping
                    enableZoom={true}
                    enablePan={true}
                    dampingFactor={0.1}
                    target={modelCenter}
                    enableRotate={enableRotate}
                />
            </Canvas>
        </div>
    );
}

export default FbxViewer;
